import './Header.scss'
import { Fragment, useEffect, useState } from 'react';
import TLEContainer from './TLEContainer';
import RightContainer from './RightContainer';
import Notification from './Notification';
import { GlobeSvg, HomeSvg, SatelliteSvg, TrueTwinSvg } from './Svgs';
import useUrlParams from '../../hooks/useUrlParams';
import ScenariInfoContainer from './ScenariInfoContainer';
import useUrlNavigation from '../../hooks/useUrlNavigation';
import CustomToolTip from '../../../CommonComponents/CustomToolTip';
import useOrbit from '../../hooks/useOrbit';
import { CircularProgress } from '@mui/material';

const Header = () => {
  const { dashboard, sat_name, truetwin_name } = useUrlParams();
  const { navigate_dashboard } = useUrlNavigation()
  const { loading } = useOrbit()

  const [locationIndicatorColor, setLocationIndicatorColor] = useState('#C0FF00')
  const [showNotification, setShowNotifications] = useState(false);
  const [showTleInfo, setShowTleInfo] = useState(false)
  const [showScenarioInfo, setShowScenarioInfo] = useState(false)

  useEffect(() => {
    const Interva = setInterval(() => {
      if (locationIndicatorColor === '#C0FF00') {
        setLocationIndicatorColor('#F2A93B')
      } else if (locationIndicatorColor === '#F2A93B') {
        setLocationIndicatorColor('#C91818')
      } else if (locationIndicatorColor === '#C91818') {
        setLocationIndicatorColor('#C0FF00')
      }
    }, 3000);
    return () => clearInterval(Interva);
  }, [])

  const toggle_scenario__info = (e) => {
    e.stopPropagation()
    if (dashboard === 'operate') {
      setShowTleInfo(!showTleInfo);
    } else {
      setShowScenarioInfo(!showScenarioInfo);
    }
    setShowNotifications(false);
  }


  const show_notification = (e) => {
    e.stopPropagation()
    setShowNotifications(true);
    setShowTleInfo(false);
    setShowScenarioInfo(false);
  }
  useEffect(() => {
    const onClick = () => {
      setShowTleInfo(false)
      setShowScenarioInfo(false)
      setShowNotifications(false)
    };
    window.addEventListener('click', onClick);
    return () => window.removeEventListener('click', onClick)
  }, [])

  return (
    <div className='command__center_header'>
      <div className='header_left_container'>
        <CustomToolTip
          title='Home'
          placement='bottom'
        >
          <button className='left_button' onClick={navigate_dashboard}>
            <HomeSvg />
          </button>
        </CustomToolTip>
        <div className={`left_button cursor-auto ${(showTleInfo || showScenarioInfo) && 'active'}`}>
          {!loading &&
            <Fragment>
              {dashboard === 'operate' ? <SatelliteSvg /> : <TrueTwinSvg />}
              <span>
                <CustomToolTip title={`${dashboard === 'operate' ? sat_name : truetwin_name}`} placement='bottom-start'>
                  {dashboard === 'operate' ? sat_name : truetwin_name}
                </CustomToolTip>
              </span>
              <CustomToolTip
                title={`${dashboard === 'operate' ? 'TLE Details' : 'Orbital Details'}`}
                placement='bottom'
              >
                <button onClick={toggle_scenario__info} className='globe__icon__badge'>
                  <GlobeSvg />
                </button>
              </CustomToolTip>
            </Fragment>
          }
          {loading && <div className='d-flex align-items-center gap-2'>
            <CircularProgress color='inherit' size={16} />
            <span className='opacity-75'>Fetching Orbit</span>
          </div>}
        </div>
        <TLEContainer open={showTleInfo} close={toggle_scenario__info} />
        <ScenariInfoContainer open={showScenarioInfo} close={toggle_scenario__info} />
        {/* <div className={`${dashboard !== 'operate' && 'show__time__info__badge'} scenario__time__info__badge`}>
          <div className='time__icon_container'>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.17888 0.0654318C3.106 0.0657162 3.03619 0.0948323 2.9847 0.14642C2.93321 0.198008 2.90424 0.267875 2.9041 0.340759V1.38925H1.23653C0.542876 1.38925 0 1.99531 0 2.7109V12.296C0 13.0116 0.542876 13.6177 1.23653 13.6177H7.67673C8.42785 14.9972 9.89028 15.9351 11.569 15.9351C14.0126 15.9351 16 13.948 16 11.504C16 9.98732 15.2344 8.64685 14.0695 7.84776V2.7109C14.0695 1.99531 13.5272 1.38925 12.8335 1.38925H11.1659V0.340759C11.1658 0.267783 11.1368 0.197836 11.0852 0.146233C11.0336 0.0946301 10.9636 0.0655759 10.8906 0.0654318C10.8544 0.0652896 10.8184 0.0723023 10.7849 0.0860685C10.7513 0.0998347 10.7208 0.120084 10.6951 0.145658C10.6693 0.171231 10.6489 0.201627 10.6349 0.235105C10.621 0.268583 10.6138 0.304486 10.6137 0.340759V1.38925H3.45581V0.340759C3.45574 0.304487 3.44852 0.268585 3.43456 0.235107C3.4206 0.20163 3.40017 0.171235 3.37445 0.145661C3.34873 0.120088 3.31821 0.0998383 3.28465 0.0860715C3.2511 0.0723046 3.21515 0.0652909 3.17888 0.0654318ZM1.23653 1.94097H2.9041V2.98785C2.90395 3.02407 2.91095 3.05997 2.92468 3.0935C2.93841 3.12702 2.95861 3.15751 2.98413 3.18323C3.00965 3.20895 3.03998 3.22938 3.07339 3.24338C3.10681 3.25737 3.14265 3.26465 3.17888 3.26479C3.21529 3.26493 3.25136 3.25786 3.28503 3.244C3.31869 3.23013 3.34928 3.20974 3.37502 3.18399C3.40076 3.15825 3.42116 3.12766 3.43502 3.09399C3.44889 3.06033 3.45596 3.02425 3.45581 2.98785V1.94097H10.6137V2.98785C10.6135 3.02426 10.6206 3.06033 10.6345 3.094C10.6483 3.12766 10.6687 3.15825 10.6945 3.18399C10.7202 3.20974 10.7508 3.23013 10.7845 3.244C10.8181 3.25787 10.8542 3.26493 10.8906 3.26479C10.9269 3.26472 10.9628 3.25749 10.9963 3.24353C11.0298 3.22957 11.0602 3.20914 11.0857 3.18342C11.1113 3.15769 11.1315 3.12718 11.1453 3.09362C11.1591 3.06006 11.1661 3.02412 11.1659 2.98785V1.94097H12.8335C13.2049 1.94097 13.5178 2.26737 13.5178 2.7109V4.76532H0.55226V2.7109C0.55226 2.26737 0.865152 1.94097 1.23653 1.94097ZM0.55226 5.31759H13.5178V7.52502C12.9293 7.23566 12.2679 7.07298 11.569 7.07298C9.12538 7.07298 7.13954 9.06003 7.13954 11.504C7.13954 12.0537 7.24058 12.5799 7.42403 13.066H1.23653C0.865152 13.066 0.55226 12.7396 0.55226 12.296V5.31759ZM11.569 7.6247C12.3265 7.6247 13.0326 7.84113 13.6293 8.21522C13.6321 8.21701 13.6348 8.21875 13.6377 8.22044C14.7261 8.90678 15.448 10.1193 15.448 11.5038C15.448 13.6497 13.714 15.3832 11.5687 15.3832C10.0497 15.3832 8.738 14.5138 8.10155 13.2447C8.09562 13.2297 8.0884 13.2153 8.07996 13.2016C7.8309 12.6891 7.6915 12.1132 7.6915 11.5039C7.6915 9.35802 9.42361 7.6247 11.569 7.6247Z" fill="#F0F0F0" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2177 9.97128C10.2177 9.55491 10.6818 9.30656 11.0282 9.53752L13.4256 11.1357C13.7351 11.3421 13.7351 11.7969 13.4256 12.0033L11.0282 13.6015C10.6818 13.8324 10.2177 13.5841 10.2177 13.1677V9.97128ZM13.1364 11.5695L10.7391 9.97128V13.1677L13.1364 11.5695Z" fill="#F0F0F0" />
            </svg>
            <span>Start Time</span>
          </div>
          <span>11th Jul, 2023  01:10 UTC</span>
        </div> */}
      </div>
      <div className='header_center_container'>
        <Notification
          show_all={showNotification}
          set_show_all={show_notification}
        />
      </div>

      <div className='header_right_container'>
        <RightContainer />
      </div>
    </div>
  )
}

export default Header